export default function isEmpty (obj) {
  if (obj.constructor !== Object) throw new Error(`${obj} is not an Object`);
  return Object.keys(obj).length === 0;
}
